import ServiceCard from '@/components/ServiceCard';
import type { Service } from '@/types/domain/service';

interface BookingServicesStepProps {
  allowMultipleServicesPerBooking: boolean;
  companyName: string;
  onToggleService: (id: string) => void;
  selectedServices: string[];
  services: Service[];
}

const BookingServicesStep = ({
  allowMultipleServicesPerBooking,
  companyName,
  onToggleService,
  selectedServices,
  services,
}: BookingServicesStepProps) => {
  return (
    <div className="animate-fade-in-up">
      <p className="text-muted-foreground mb-5 text-sm">
        Selecione os serviços desejados em <strong className="text-foreground">{companyName}</strong>
      </p>
      {!allowMultipleServicesPerBooking && (
        <p className="text-muted-foreground mb-5 text-sm">
          Este estabelecimento permite apenas 1 serviço por agendamento.
        </p>
      )}
      <div className="space-y-3">
        {services.map((service) => (
          <ServiceCard
            key={service.id}
            service={{
              ...service,
              duration: `${service.durationMin} min`,
            }}
            selected={selectedServices.includes(service.id)}
            onToggle={onToggleService}
            disabled={
              !allowMultipleServicesPerBooking && selectedServices.length > 0 && !selectedServices.includes(service.id)
            }
          />
        ))}
      </div>
    </div>
  );
};

export default BookingServicesStep;
